Pegasus.CandyToggle = Em.View.extend({
  templateName: 'controls/candy_toggle',
  classNameBindings: ['context.isClean:clean:working', 'toggled:on:off', 'context.isInvalid:invalid'],
  toggled: Em.required(),
  userData: Em.required(),
  _leftPositionLabel: function(){
    if ( !this.get('leftPositionLabel') ) { return ""; }
    return Em.I18n.t(this.get('leftPositionLabel'));
  }.property('leftPositionLabel'),
  _rightPositionLabel: function(){
    if ( !this.get('rightPositionLabel') ) { return ""; }
    return Em.I18n.t(this.get('rightPositionLabel'));
  }.property('rightPositionLabel'),
  mouseUp: function(){
    this.get('controller').send('didCandyToggle', this.get('userData'), this.get('context'));
  },
  click: function(e){
    e.preventDefault();
    e.stopPropagation();
  }
});

Pegasus.WhiteCandyToggle = Pegasus.CandyToggle.extend({
  classNames: ['white-toggle', 'vr-switch-toggle']
});

Handlebars.registerHelper('CandyToggle', function(options) {
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.CandyToggle, options);
});

Handlebars.registerHelper('WhiteCandyToggle', function(options) {
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.WhiteCandyToggle, options);
});
